import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19837 18447"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:566.785}.fil0{fill:#1c1b17}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M11495 15941c0 868-709 1575-1578 1575s-1574-707-1574-1575c0-869 705-1576 1574-1576 870 0 1578 707 1578 1576zm-3799 0c0 1225 999 2223 2221 2223 1226 0 2222-998 2222-2223 1-1226-996-2223-2222-2223-1222 0-2221 997-2221 2223zM18811 5129c-122 121-339 118-458-5-2239-2288-5238-3546-8436-3546-3196 0-6192 1258-8433 3546-60 62-141 96-227 96-88 0-168-31-230-91-61-61-96-142-97-228 0-87 33-168 92-230C3386 2259 6546 930 9917 930c3376 0 6536 1329 8899 3741 59 62 93 143 93 230-4 86-38 167-98 228zM9917 283c-3546 0-6870 1398-9356 3935-181 185-280 430-278 690 3 259 106 502 291 682 183 180 424 278 679 278h11c259-3 501-106 683-291 2118-2162 4949-3353 7970-3353 3024 0 5853 1191 7974 3352 182 188 428 292 691 292 259 0 497-99 679-278 187-180 289-423 293-682 4-260-98-505-276-690-2490-2537-5811-3935-9361-3935z"
        className="fill storke1"
        style={{
          strokeWidth: 566.785,
        }}

      />
      <path
        d="M3958 8578c-125 128-329 131-458 7-128-124-131-329-7-457 1704-1753 3985-2718 6424-2718 2443 0 4725 965 6426 2718 123 127 123 333-5 457-127 121-339 117-458-7-1582-1626-3698-2521-5963-2521-2262-1-4379 895-5959 2521zm12156 745c250 0 492-97 674-274 382-373 390-988 21-1372-1827-1880-4275-2915-6892-2915-2615 0-5062 1035-6888 2915-372 384-364 999 20 1372s1000 363 1373-20c1456-1500 3409-2326 5495-2326 2091 0 4042 827 5497 2326 186 189 432 294 700 294zM6226 12394c-60 62-140 98-227 99-86 1-168-29-231-89-62-59-98-140-100-226s31-169 90-231c1097-1149 2575-1781 4159-1781 1586 0 3067 632 4161 1781 59 62 93 145 89 231 0 86-34 167-98 226-127 120-339 115-458-10-975-1020-2286-1581-3694-1581-1404 0-2717 561-3691 1581zm7619 747c250 0 487-96 670-269 186-179 297-420 301-679 4-260-89-506-267-693-1222-1277-2868-1981-4632-1981-1762 0-3406 704-4627 1981-178 187-274 433-268 693 6 259 112 500 300 679 181 174 419 269 670 269 7 0 15 0 22-1 260-5 501-111 679-299 851-891 1998-1382 3224-1382 1230 0 2375 491 3228 1382 182 190 437 300 700 300z"
        className="fill storke1"
        style={{
          strokeWidth: 566.785,
        }}
      />
    </g>
  </svg>
)
export default SvgComponent
